import { getOfferGroupType } from 'components/card/Buyers/Context/backend-driven-offer-helpers.js';

const normalizeBidSaleId = (bidSaleId) => {
	const parsedBidSaleId = Number(bidSaleId);
	return Number.isNaN(parsedBidSaleId) ? bidSaleId : parsedBidSaleId;
};

const normalizeNewStructOfferData = (offerData) => {
	const groupType = getOfferGroupType(offerData);

	return {
		bid_sale_id: normalizeBidSaleId(offerData?.bid_sale_id),
		version: offerData?.version,
		group_type: groupType,
	};
};

export const normalizeBackendDrivenOfferSummaryRow = (offerData) => normalizeNewStructOfferData(offerData);

const backendDrivenGroupTypeToSummaryKey = {
	leader: 'leaderCount',
	outbid: 'outbiddedCount',
	won: 'wonCount',
	lost: 'lostCount',
	counter: 'counterCount',
};

const calculateSummaryForBackendDrivenItem = (summaryCalculation, bidSale) => {
	const summaryKey = backendDrivenGroupTypeToSummaryKey[bidSale.group_type];
	if (!summaryKey) return summaryCalculation;

	return {
		...summaryCalculation,
		[summaryKey]: summaryCalculation[summaryKey] + 1,
	};
};

const initialSummaryStats = {
	leaderCount: 0,
	outbiddedCount: 0,
	wonCount: 0,
	lostCount: 0,
	counterCount: 0,
};

export const calculateBackendDrivenSummaryFromList = ({ bidSalesThatUserHasOfferer }) => {
	return bidSalesThatUserHasOfferer.reduce(
		({ leaderCount, outbiddedCount, wonCount, lostCount, counterCount }, bidSale) =>
			calculateSummaryForBackendDrivenItem(
				{ leaderCount, outbiddedCount, wonCount, lostCount, counterCount },
				bidSale,
			),
		initialSummaryStats,
	);
};
